import { render, staticRenderFns } from "./ReturnDeliveryAmount.vue?vue&type=template&id=4d438958&"
import script from "./ReturnDeliveryAmount.vue?vue&type=script&lang=ts&"
export * from "./ReturnDeliveryAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports